// extracted by mini-css-extract-plugin
export default {"tx":"_76cd133418","line":"b53ea48e24"};